import React from "react";

const SvgIcnExportListDevice = props => (
  <svg
    id="icn_export_list_device_svg__\u30EC\u30A4\u30E4\u30FC_1"
    data-name="\u30EC\u30A4\u30E4\u30FC 1"
    width={24}
    height={24}
    {...props}
  >
    <defs>
      <style>{".icn_export_list_device_svg__cls-1{fill:#4a4b4c}"}</style>
    </defs>
    <path
      className="icn_export_list_device_svg__cls-1"
      d="M3 20h18v2H3zM11 3h2v10h-2z"
    />
    <path
      className="icn_export_list_device_svg__cls-1"
      d="M17 7H7l5-5 5 5zM3 7h2v15H3zM19 7h2v15h-2z"
    />
    <path
      className="icn_export_list_device_svg__cls-1"
      d="M3 7h3v2H3zM18 7h3v2h-3z"
    />
  </svg>
);

export default SvgIcnExportListDevice;
